export default "__VITE_ASSET__CyOiEdmh__"